import { IdmClientContext } from "@sista/idm-client";
import { buildWorkflowClient } from "@sista/library-stasi";
import { useContext, useMemo } from "react";

export const useWorkflowClient = () => {
  //console.debug("Getting IdmClient");
  const c = useContext(IdmClientContext);

  if (c == null) {
    throw new Error("IdmClientContext is null");
  }

  const authKeyToUse = c?.loggedAccount?.authKey;
  return useMemo(
    () =>
      buildWorkflowClient(process.env.REACT_APP_WORKFLOW_ROOT, authKeyToUse),
    [authKeyToUse]
  );
};
